
import { FIREARM_STORAGE_LOCATION_PLI_METADATA } from './firearm-storage-location-pli.metadata';
import { FirearmStorageLocationPLIBase } from './firearm-storage-location-pli.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface FirearmStorageLocationPLI extends FirearmStorageLocationPLIBase {
}

export interface FirearmStorageLocationPLITransient { }

export class FirearmStorageLocationPLI extends CrudEntity<FirearmStorageLocationPLI, number, FirearmStorageLocationPLITransient> implements FirearmStorageLocationPLITransient {
  constructor(source?: Partial<FirearmStorageLocationPLI>, options?: CrudEntityConstructionOptions<FirearmStorageLocationPLI, number, FirearmStorageLocationPLITransient>) {
    super(FIREARM_STORAGE_LOCATION_PLI_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





